/* global modForm*/
import { getCurrentStep } from '../helpers';
/**
 * Checks if current step is the last one
 * @returns {Bool} - true if current step is last, false if not
 */
export function isCurrentStepSecondToLast() {
	return (modForm.opts.steps.length - Array.from(modForm.opts.steps).indexOf(getCurrentStep())) === 2;
}
